import { Component, OnInit } from '@angular/core';
import { OrderService } from 'src/app/services/order.service';
import { ToastrService } from 'ngx-toastr';
import { FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContentComponent } from 'src/app/modal/modal.component';
import { Agency } from 'src/app/model/agency';

interface ResultType {
  a?: string;
  b?: string;
  c?: string;
  d?: string;
  e?: string;
  f?: string;
  h?: string;
  i?: number;
  j?: number;
  k?: string;
  l?: string;
  m?: string;
  n?: string;
  o?: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  [x: string]: any;
  alertNomClient = false;
  alertVille = false;
  alertAdmin = false;
  alertClientSap = false;
  alertEmailAdmin = false;
  alertEmailAdminConfirm = false;
  alertNbAboHaccp = false;
  alertAboDuree = false;
  alertValidateur = false;
  alertValidateurHe = false;
  alertCodeValidation = false;
  alertFormule = false;
  alertEmailValidateur = false;
  alertEmailCommercial = false;
  alertNbAboSonde = false;
  showNumeroCommande = false;
  disableValidateButton = false;
  disableReinitButton = true;
  numeroCommande: string;
  formList: any;
  timezoneList: any;
  agencyList: any;
  agencyMap: Map<string, number> = new Map();
  actifInput = true;
  emailAdmin: any;
  indexEmail: any;
  emailAdminConfirm: any;
  indexEmailConfirm: any;
  emailValid: any;
  indexEmailValid: any;
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$';
  selectedValue: string;
  selectedTimezone: number;
  defaultOrder = {
    nom_client: null,
    ville: null,
    admin: null,
    numero_client_sap: null,
    email_admin: null,
    email_admin_confirm: null,
    nb_abo_haccp: 0,
    nb_abo_sonde: 0,
    abo_duree: 12,
    formule: 0,
    liaisonFormFilledBySalesperson: 'non',
    validateur: null,
    email_validateur: null,
    email_commercial: null,
    code_validation: null,
    timezone: 331,
    geozone: 'Europe/',
  };
  agencys: Agency[] = [];

  constructor(
    private orderService: OrderService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {}

  async ngOnInit() {
    this.orderService.getListTimezone().subscribe((timezone: any) => {
      this.timezoneList = timezone.filter((x) => x.iana_tz.includes('Europe/'));
    });
    this.orderService.getListForm().subscribe((order: any) => {
      this.formList = order.filter(
        (x) =>
          x.label.toLowerCase() === 'essential' ||
          x.label.toLowerCase() === 'basic' ||
          x.label.toLowerCase() === 'premium'
      );
    });
    const params = new URLSearchParams(document.location.search);

    // const data = await this.orderService.getListAgency().toPromise();
    const agencyData = await this.orderService.getListAgency().toPromise();
    this.agencys = agencyData;

    if (params.get('data')) {
      // const data = decodeURIComponent(atob(decodeURI(params.get('data'))));
      const urlData = decodeURIComponent(atob(decodeURI(params.get('data'))));
      const result: ResultType = urlData.split('&').reduce((obj, item) => {
        const [key, value] = item.split('=');
        obj[key] = value.split('+').join(' ');
        return obj;
      }, {});
      if (result.a) {
        this.defaultOrder.nom_client = result.a;
      }
      if (result.b) {
        this.defaultOrder.ville = result.b;
      }
      if (result.c && result.d) {
        this.defaultOrder.admin = result.c + ' ' + result.d;
      }
      if (result.f) {
        this.defaultOrder.email_admin = result.f.replace('.invalid', '');
        this.defaultOrder.email_admin_confirm = result.f.replace(
          '.invalid',
          ''
        );
      }
      if (result.h) {
        switch (result.h) {
          case 'essential':
            this.defaultOrder.formule = 2;
            break;
          case 'basic':
            this.defaultOrder.formule = 6;
            break;
          case 'premium':
            this.defaultOrder.formule = 4;
            break;
          default:
            this.defaultOrder.formule = 2;
            break;
        }
      }
      if (result.i) {
        this.defaultOrder.nb_abo_haccp = result.i;
      }
      if (result.j) {
        this.defaultOrder.nb_abo_sonde = result.j;
      }
      if (result.k) {
        this.defaultOrder.abo_duree = parseInt(result.k, null);
      }
      if (result.l) {
        switch (result.l) {
          case 'true':
            this.defaultOrder.liaisonFormFilledBySalesperson = 'oui';
            break;
          case 'false':
            this.defaultOrder.liaisonFormFilledBySalesperson = 'non';
            break;
          default:
            this.defaultOrder.liaisonFormFilledBySalesperson = 'non';
            break;
        }
      }
      if (result.m) {
        this.orderService.saveValidateur(result.m).subscribe(
          (response: any) => {
            console.log(response);
          },
          (error) => {
            console.error('erreur', error);
          }
        );
        this.defaultOrder.validateur = this.getSelectValueFromData(result.m);
      }
      if (result.e && this.defaultOrder.validateur != null) {
        this.defaultOrder.numero_client_sap = this.getSapNumber(
          result.e,
          this.defaultOrder.validateur
        );
      }
      if (result.n) {
        this.defaultOrder.email_validateur = result.n.replace('.invalid', '');
      }
      if (result.o) {
        this.defaultOrder.email_commercial = result.o;
      }
    }
  }

  getSapNumber(str: string, agencyId: number) {
    const agencyName = this.agencys.find((x) => x.id === agencyId).name;
    if (agencyName.includes('JDC') || agencyName.includes('HAXE DIRECT')) {
      const splitSap = str.split(' - ');
      if (agencyName.includes('JDC')) {
        const element = splitSap.find((x) => x.includes('(JDC)'));
        if (element !== undefined) {
          return element.replace('(JDC)', '');
        }
      } else {
        const element = splitSap.find((x) => x.includes('SF-'));
        if (element !== undefined) {
          return element;
        }
      }
    }
    return null;
  }

  getSelectValueFromData(dataValue: string): number | null {
    if (!dataValue) {
      return null;
    }

    // Normalisation (supprime les accents, majuscules)
    const normalize = (s: string) =>
      s
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase()
        .replace(/[- ]/g, '')
        .trim();

    const normalized = normalize(dataValue);

    // --- Liste des agences racines ---
    const roots = ['HYGIENEEXPERT', 'POPINA', 'HAXEDIRECT', 'JDC'];

    const exactRoot = roots.find((r) => normalized === r);
    if (exactRoot) {
      const agency = this.agencys.find((a) => normalize(a.name) === exactRoot);
      return agency.id;
    }

    // --- Trouve l'agence racine contenue dans le texte ---
    const rootFound = roots.find((r) => normalized.includes(r));

    // --- Nettoyage du nom : enlever la racine trouvée ---
    const cleanName = normalized.replace(rootFound, '');

    // --- Filtrage des agences correspondantes ---
    const agenciesFiltered = this.agencys.filter((a) =>
      normalize(a.name).includes(rootFound)
    );

    // Recherche exacte
    const agencyMatch = agenciesFiltered.find(
      (a) => normalize(a.name).replace(rootFound, '') === cleanName
    );

    return agencyMatch.id;
  }

  onOptionsSelected(value) {
    if (value === '6') {
      this.actifInput = false;
    } else {
      this.actifInput = true;
    }
  }
  onGeozoneSelected(value) {
    this.orderService.getListTimezone().subscribe((data: any) => {
      this.timezoneList = data.filter((x) => x.iana_tz.includes(value));
      if (value === 'Europe/') {
        this.selectedTimezone = 331;
      }
    });
  }
  onValidateurChange(orderForm, $event) {
    this.abo = orderForm.value.nb_abo_haccp;
    this.event = $event;
    this.nbAboMin = 3;

    // Récupérer le nom de l'agence depuis l'ID
    const selectedAgency = this.agencys.find((a) => a.id === orderForm.value.validateur);
    const agencyName = selectedAgency ? selectedAgency.name : '';

    if (agencyName !== 'HYGIENE EXPERT') {
      if (this.abo > this.nbAboMin) {
        this.open(this.event);
      }
    }
  }
  open(event) {
    event.srcElement.blur();
    event.preventDefault();
    this.modalService.open(NgbdModalContentComponent);
  }

  /**
   * Soumission du formulaires
   * @param orderForm formulaire
   */
  onFormSubmit(orderForm) {
    const tabOrder: any = {};
    tabOrder.nom_client = orderForm.nom_client;
    tabOrder.ville = orderForm.ville;
    tabOrder.admin = orderForm.admin;
    tabOrder.numero_client_sap = orderForm.numero_client_sap;
    tabOrder.email_admin = orderForm.email_admin.trim();
    tabOrder.formule = orderForm.formule;
    tabOrder.nb_abo_haccp = orderForm.nb_abo_haccp;
    tabOrder.nb_abo_sonde = orderForm.nb_abo_sonde;
    tabOrder.abo_duree = orderForm.abo_duree;
    tabOrder.support_agency_id = orderForm.validateur;
    tabOrder.email_validateur = orderForm.email_validateur.trim();
    tabOrder.email_commercial = orderForm.email_commercial.trim();
    tabOrder.code_validation = orderForm.code_validation;
    tabOrder.appli_timezone_id = orderForm.timezone;
    tabOrder.liaisonFormFilledBySalesperson =
      orderForm.liaisonFormFilledBySalesperson !== 'non';
    // si le formulaire est correctement remplis on envoi les données
    if (this.isformOk(orderForm)) {
      this.disableValidateButton = true;
      this.orderService.postOrder(tabOrder).subscribe(
        (data: any) => {
          this.resetalerts();
          // affichage du numero de commande
          this.numeroCommande = data.numero_commande;
          this.showNumeroCommande = true;
          // activation du bouton réinitialisation du formulaire
          this.disableReinitButton = false;
        },
        (error) => {
          console.error('erreur', error);
          this.disableValidateButton = false;
          try {
            const stat = 'status';
            if (error[stat] === 401) {
              this.alertCodeValidation = true;
            } else {
              this.toastr.error('erreur');
            }
          } catch (errorbis) {
            console.error('erreur', errorbis);
          }
        }
      );
    }
  }

  /**
   * réinitialisation du formulaire de la page
   * @param orderForm formulaire a reinitialiser
   */
  resetOrderForm(orderForm) {
    this.disableValidateButton = false;
    this.disableReinitButton = true;
    this.resetalerts();
    const nomCli = 'nom_client';
    const vil = 'ville';
    const admin = 'admin';
    const numCliSap = 'numero_client_sap';
    const emailAdmin = 'email_admin';
    const emailAdminConfirm = 'email_admin_confirm';
    const nbAboHaccp = 'nb_abo_haccp';
    const nbAboSonde = 'nb_abo_sonde';
    const aboDuree = 'abo_duree';
    const formule = 'formule';
    // const liaisonFormFilledBySalesperson = 'liaisonFormFilledBySalesperson';
    const geozone = 'geozone';
    const geozoneDefaultValue = 'Europe/';
    orderForm.controls[nomCli].reset();
    orderForm.controls[vil].reset();
    orderForm.controls[admin].reset();
    orderForm.controls[numCliSap].reset();
    orderForm.controls[emailAdmin].reset();
    orderForm.controls[emailAdminConfirm].reset();
    orderForm.controls[geozone].setValue(geozoneDefaultValue);
    this.onGeozoneSelected(geozoneDefaultValue);
    if (orderForm.value[formule] === '6') {
      orderForm.controls[nbAboSonde].reset();
      orderForm.controls[aboDuree].reset();
      orderForm.controls[formule].reset();
    } else {
      orderForm.controls[nbAboHaccp].reset();
      orderForm.controls[nbAboSonde].reset();
      orderForm.controls[aboDuree].reset();
      orderForm.controls[formule].reset();
    }
  }
  // vérifie si le formulaire est correct
  isformOk(orderForm) {
    let isok = true;
    this.resetalerts();
    if (orderForm.nom_client === null || orderForm.nom_client === '') {
      this.alertNomClient = true;
      isok = false;
    }
    if (orderForm.ville === null || orderForm.ville === '') {
      this.alertVille = true;
      isok = false;
    }
    if (orderForm.admin === null || orderForm.admin === '') {
      this.alertAdmin = true;
      isok = false;
    }
    if (
      orderForm.numero_client_sap === null ||
      orderForm.numero_client_sap === ''
    ) {
      this.alertClientSap = true;
      isok = false;
    }
    if (orderForm.email_admin === null || orderForm.email_admin === '') {
      this.alertEmailAdmin = true;
      isok = false;
    }
    if (
      orderForm.email_admin_confirm === null ||
      orderForm.email_admin_confirm === '' ||
      orderForm.email_admin !== orderForm.email_admin_confirm
    ) {
      this.alertEmailAdminConfirm = true;
      isok = false;
    }
    if (
      (orderForm.nb_abo_haccp === null ||
      orderForm.nb_abo_haccp === '' ||
      orderForm.nb_abo_haccp === 0 ||
      orderForm.nb_abo_haccp === '0') && parseInt(orderForm.formule, null) !== 6
    ) {
      this.alertNbAboHaccp = true;
      isok = false;
    }
    if (
      (orderForm.nb_abo_sonde === null ||
      orderForm.nb_abo_sonde === '' ||
      orderForm.nb_abo_sonde === 0 ||
      orderForm.nb_abo_sonde === '0') && parseInt(orderForm.formule, null) === 6
    ) {
      this.alertNbAboSonde = true;
      isok = false;
    }
    if (orderForm.abo_duree === null || orderForm.abo_duree === '') {
      this.alertAboDuree = true;
      isok = false;
    }
    if (orderForm.validateur === null || orderForm.validateur === '') {
      this.alertValidateur = true;
      isok = false;
    }
    if (orderForm.formule === null || orderForm.formule === '' ||  orderForm.formule === '0' ||  orderForm.formule === 0) {
      this.alertFormule = true;
      isok = false;
    }
    if (
      orderForm.code_validation === null ||
      orderForm.code_validation === ''
    ) {
      this.alertCodeValidation = true;
      isok = false;
    }
    if (
      orderForm.email_validateur === null ||
      orderForm.email_validateur === ''
    ) {
      this.alertEmailValidateur = true;
      isok = false;
    }

    if (
      orderForm.email_commercial === null ||
      orderForm.email_commercial === ''
    ) {
      this.alertEmailCommercial = true;
      isok = false;
    }
    return isok;
  }
  // reinitialisation des messages d'alertes
  resetalerts() {
    this.alertNomClient = false;
    this.alertVille = false;
    this.alertAdmin = false;
    this.alertEmailAdmin = false;
    this.alertEmailAdminConfirm = false;
    this.alertNbAboHaccp = false;
    this.alertNbAboSonde = false;
    this.alertAboDuree = false;
    this.alertValidateur = false;
    this.alertEmailValidateur = false;
    this.alertEmailCommercial = false;
    this.alertCodeValidation = false;
    this.showNumeroCommande = false;
    this.alertClientSap = false;
    this.alertFormule = false;
  }

  // copie une chaine de caratères dans le presse-papier
  copyMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}
